import APIService from '@/services/APIService.js';

export default {
  indicadoresDashboard(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/dashboard/indicadores', {
      params: { ...filtros }
    });
  },

  responsaveisPrazosDashboard(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/dashboard/responsaveis-prazos', {
      params: { ...filtros }
    });
  },

  concentracaoDashboard(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/dashboard/concentracao', {
      params: { ...filtros }
    });
  },

  recorrenciaOrigemDashboard(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/dashboard/recorrencia-origem', {
      params: { ...filtros }
    });
  },

  situacaoEvolucaoDashboard(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/dashboard/situacao-evolucao', {
      params: { ...filtros }
    });
  }
};
